"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/stable/promise");
require("whatwg-fetch");
var ready = function (fn) {
    if (typeof fn !== 'function')
        return;
    if (document.readyState === 'complete') {
        return fn();
    }
    document.addEventListener('DOMContentLoaded', fn, false);
};
ready(function () {
    (function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, count, el, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4, fetch(cartCountUrl)];
                case 1: return [4, (_a.sent()).json()];
                case 2:
                    response = _a.sent();
                    if (response.result === 'OK') {
                        count = Number(response.count);
                        el = document.getElementById("cartCount");
                        if (count) {
                            el.classList.remove("label-default");
                            el.classList.add("label-danger");
                        }
                        else {
                            el.classList.remove("label-danger");
                            el.classList.add("label-default");
                        }
                        el.textContent = count.toString();
                    }
                    else {
                        console.error(response);
                    }
                    return [3, 4];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); })();
    function requestCart() {
        return __awaiter(this, void 0, void 0, function () {
            var formData, rawResponse, content, count, el, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append(csrfParam, csrfToken);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4, fetch(showCartUrl, {
                                method: 'POST',
                                headers: new Headers({ 'X-Is-Ajax-Request': 'True' }),
                                body: formData
                            })];
                    case 2:
                        rawResponse = _a.sent();
                        return [4, rawResponse.text()];
                    case 3:
                        content = _a.sent();
                        document.getElementById("carttable").innerHTML = content;
                        document.getElementById('cartloader').style.display = 'none';
                        count = Number(document.querySelector('[data-cartcount]').getAttribute('data-cartcount'));
                        if (count) {
                            document.getElementById("btCheckout").removeAttribute("disabled");
                            document.querySelectorAll('.cart-inc, .cart-dec, .cart-del').forEach(function (item) {
                                item.addEventListener('click', function (event) { return __awaiter(_this, void 0, void 0, function () {
                                    var rawResponse_1, response, err_3;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                event.preventDefault();
                                                _a.label = 1;
                                            case 1:
                                                _a.trys.push([1, 4, , 5]);
                                                return [4, fetch(item.getAttribute("href"), {
                                                        headers: new Headers({ 'X-Is-Ajax-Request': 'True' })
                                                    })];
                                            case 2:
                                                rawResponse_1 = _a.sent();
                                                return [4, rawResponse_1.json()];
                                            case 3:
                                                response = _a.sent();
                                                if (response.result === 'OK')
                                                    requestCart();
                                                else
                                                    console.error(response);
                                                return [3, 5];
                                            case 4:
                                                err_3 = _a.sent();
                                                console.error(err_3);
                                                return [3, 5];
                                            case 5: return [2];
                                        }
                                    });
                                }); });
                            });
                        }
                        else {
                            document.getElementById("btCheckout").setAttribute("disabled", "disabled");
                            el = document.getElementById("cartCount");
                            el.classList.remove("label-danger");
                            el.classList.add("label-default");
                            el.textContent = count.toString();
                        }
                        return [3, 5];
                    case 4:
                        err_2 = _a.sent();
                        console.error(err_2);
                        alert('Виникла помилка!');
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    }
    var btShowCart = document.getElementById("btShowCart");
    btShowCart.setAttribute('href', '#');
    btShowCart.addEventListener('click', function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    if (!document.querySelector('[name=checkout-page]')) return [3, 1];
                    event.stopPropagation();
                    return [3, 3];
                case 1: return [4, requestCart()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2];
            }
        });
    }); });
    var btCheckout = document.getElementById("btCheckout");
    btCheckout.addEventListener('click', function () {
        history.pushState({}, "", window.location.href);
        window.location.replace(cartIndexUrl);
    });
});
